export const useCases = [
  {
    title: 'Condition education',
    job: 'Scientific storytelling',
    line: 'Turn a complex evidence story into short, interactive chapters.',
    icon: 'book',
  },
  {
    title: 'Webinar replay series',
    job: 'Content repurposing',
    line: 'Transform one live session into a replayable episode series.',
    icon: 'play',
  },
  {
    title: 'Dosing guidance',
    job: 'Practical education',
    line: 'Make application and titration guidance easy to explore in minutes.',
    icon: 'route',
  },
  {
    title: 'Website engagement',
    job: 'Digital activation',
    line: 'Give existing traffic something useful to do, not just something to read.',
    icon: 'cursor',
  },
  {
    title: 'Patient education',
    job: 'Guided support',
    line: 'Adapt approved material into a clear, guided patient experience.',
    icon: 'heart',
  },
  {
    title: 'Remote market support',
    job: 'Always-on reach',
    line: 'Keep essential education accessible without a local field team.',
    icon: 'globe',
  },
] as const
